import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg  px-3 nav-col">
      <div className="container">
        <Link className="navbar-brand site-name" to="/">TalkieTalks</Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav">
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse nav-text" id="mainNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item"><Link className="nav-link" to="/movies">Movies</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/politics">Politics</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/contact">Contact Us</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/feedback">Feedback</Link></li>
          </ul>
        </div>
      </div>
           <ul className="navbar-nav ms-auto">
          <li>
            <Link
              to="/uploadarticles"
              className="position-absolute top-0 end-0 me-3 mt-2 new-top-link nav-link d-none d-lg-block"
            >
              Upload Articles
            </Link>
          </li>
        </ul>
    </nav>
  );
}

export default Navbar;
